import { useMutation } from '@tanstack/react-query';

import { useSnackbar } from 'notistack';

import { CabinEventClient, CabinEventReportDTO, ProblemDetails } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const cabinEventClient = new CabinEventClient(apiBaseUrl);

function useApproveCabinEvent() {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation<CabinEventReportDTO, ProblemDetails, number>({
    mutationKey: [queryKeys.CabinEvent.Approve],
    mutationFn: (reportId: number) => cabinEventClient.approve(reportId),
    onError: (error) => {
      const statusMessage = error.status === 409
        ? 'Form data has changed on the server, please refresh the page and try again.'
        : 'An unexpected error has occurred.';

      enqueueSnackbar(statusMessage, { variant: 'error', persist: true });
    },
  });
}

export default useApproveCabinEvent;
